/**
 * The category for the products
 * @author Ka Wing Chin <kawing.chin@takeaway.com>
 * @class Takeaway.Category
 */

import Utils from '../lib/utils'

export default class Category {
  constructor () {
    this.orderTimes = []
    this.exceptionTimes = []
  }

  /**
   * @enum Restaurant OpeningStatus
   * @property {Number} OpeningStatus.Closed Restaurant is closed.
   * @property {Number} OpeningStatus.Open Restaurant is open.
   * @property {Number} OpeningStatus.PreOrder Restaurant can be preordered.
   */
  static Status = Object.freeze({
    Closed: 0,
    Open: 1,
    PreOrder: 2
  })

  /**
   * @property {string} id of the category.
   */
  id
  /**
   * @property {Array<TimeWindow>} ordertimes.
   */
  orderTimes
  /**
   * @property {Array<TimeWindow>} exceptionTimes.
   */
  exceptionTimes
  /**
   * The status of the category.
   * @property {Category.Status} status
   */
  status
  /**
   * The current time the category is now. For multiple order times. It will pick the last one.
   * This is kinda stupid in the code.
   */
  currentOrderTime
  /**
   * List of product ids.
   * @property {Array<string>}
   */
  productIds

  /**
   * Validate order time. If there is no order time, it means it should be available.
   * The result will be set on status.
   * @param {moment} time the time
   * @param {int} weekDay the day of the week
   * @return {Category.Status} The status of the category.
   */
  validateOrderTime (time, weekDay) {
    var orderTimes = []
    // Check if there is an exception time for today
    if (this.exceptionTimes.length > 0) {
      var date = Utils.getDate(time)
      orderTimes = this.exceptionTimes.filter(function (exceptionTime) {
        return exceptionTime.date.isSame(date)
      })
    }

    // Do regular times if there are no exception times.
    if (orderTimes.length === 0) {
      orderTimes = this.orderTimes.filter(function (orderTime) {
        return orderTime.weekDay === weekDay
      })
    }

    var status = Category.Status.Open
    if (orderTimes.length > 0) {
      status = Category.Status.Closed
      for (var x in orderTimes) {
        var orderTime = orderTimes[x]
        this.currentOrderTime = orderTime // argghhh this shouldn't be here
        var startTime = Utils.timeToToday(orderTime.startTime, time)
        var endTime = Utils.timeToToday(orderTime.endTime, time)

        // If category is set to 00:00 then the category is not available.
        if (Utils.getSeconds(startTime) === 0 && Utils.getSeconds(endTime) === 0) {
          return Category.Status.Closed
        }

        var timeStatus = Utils.checkTimeBetween(orderTime, time, time)
        if (timeStatus === Utils.TimeStatus.Before) {
          return Category.Status.PreOrder
        }

        if (timeStatus === Utils.TimeStatus.Between) {
          return Category.Status.Open
        }
      }
    }
    return status
  }

  /**
   * Validate the category by server date time. The result will be in Category.status.
   * @param {ServerDateTime} serverDateTime The time + weekday from the server.
   * @return {Category.Status} The status of the category.
   */
  validateOrderTimeByServerTime (serverDateTime) {
    this.status = this.validateOrderTime(serverDateTime.time, serverDateTime.weekDay)
    return this.status
  }
}
